import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { skipToken } from "@reduxjs/toolkit/query";
import { DateTime } from "luxon";
import { t } from "i18next";

import { CalendarUser } from "@/shared/components/organisms/CalendarUser";
import { ButtonSoft } from "@/shared/components/atoms/ButtonSoft";
import { InputCheck } from "@/shared/components/atoms/InputCheck";
import { TabsUser } from "@/shared/components/organisms/TabsUser";


import { useLessonsUserQuery } from "@/app/lessons/lessons.api";

export const LessonsAssignment = ({
  branch_id,
  handleOpenDialogAsingLessons,
}: any) => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [userSelected, setUserSelected] = useState<any>(null);

  useEffect(() => {
    if (id) {
      setUserSelected(id);
    }
  }, [id]);

  const [idBranch, setIdBranch] = useState(0);
  const [month, setMonth] = useState(DateTime.now().toFormat("yyyy-MM"));

  useEffect(() => {
    if (branch_id) {
      setIdBranch(branch_id);
    }
  }, [branch_id]);

  //TABS ACTIVIDADES DIRIGIDAS
  const [selectedTabAD, setSelectedTabAD] = useState(1);
  const tabsAD = [{ id: 1, name: t("lesson.views.calendar") }];
  const handleTabChangeAD = (tabId: any) => {
    setSelectedTabAD(tabId);
  };

  const lessonsUserQuery = useLessonsUserQuery(
    idBranch > 0 ? { branchId: idBranch, userId: userSelected, month: month } : skipToken
  );

  return (
    <>
      <h1 className="text-base font-semibold leading-6 text-gray-900 border-b border-gray-200 pb-3 mt-10  mb-5 md:mb-3">
        {t("calendar.lessons")}
      </h1>
      <TabsUser
        tabs={tabsAD}
        selectedTab={selectedTabAD}
        handleTabChange={handleTabChangeAD}
        button={
          <ButtonSoft
            text={t("user.views.manage_lessons")}
            onClick={() => navigate(`/branchs/${idBranch}/events/directed-activities`)}
            size="large"
          />
        }
      />
      <div className="w-full">
        <div className="flex items-center justify-center space-x-2 mt-4">
          <InputCheck
            id="permitir_reserva"
            onClick={(event) => { }}
            onChange={(event) => {
              if (event.target.checked) {
                setUserSelected(undefined);
                lessonsUserQuery.refetch();
              }else {
                setUserSelected(id);
                lessonsUserQuery.refetch();
              }
            }}
          />
          <label
            htmlFor="permitir_reserva"
            className="text-gray-900 text-sm">
            {t("user.views.permitir_reserva")}
          </label>
        </div>

        <CalendarUser
          initialDateTime={DateTime.now()}
          events={lessonsUserQuery.data ?? []}
          loading={lessonsUserQuery.isLoading || lessonsUserQuery.isFetching }
          functionOpenModalActividades={() => {}}
          onEventClick={(lesson) => {
            handleOpenDialogAsingLessons(lesson);
          }}
          onMonthChange={(date) => {
            setMonth(date.toFormat("yyyy-MM"));
            lessonsUserQuery.refetch();
          }}
        />
      </div>

      

    </>
  );
}